// extracted by mini-css-extract-plugin
export default {"cardsContainer":"UserProfile_cardsContainer__Zf94d"};